import { useEffect, useState } from "react";
import { useApp } from "../../hooks/AppProvider";
import { motion } from 'framer-motion';
import "../../css/animation/role.css"

function RoleAnimation() {
    let app = useApp();

    let [phase, setPhase] = useState("enter");
    let [roles, setRoles] = useState([]);
    let [currentIndex, setCurrentIndex] = useState(0);
    let [update, setUpdate] = useState(0);

    useEffect(() => {
        app.sendGet("/role/listmy", data => {
            setRoles(data);
            
        });
    }, []);

    function next() {
        setPhase("exit");
        
        setUpdate(update + 1);
    }

    function end() {
        app.navigate("/app/role")
    }

    const variants = {
        initial: { x: "100vw", transition: { duration: 0}},   // départ à droite
        enter: { x: 0, opacity: 1 },           // centre
        exit: { x: "-100vw"},      // sortie à gauche
    };

    return (
        <>
        <div className="main-back">
            <div className="main-back-titlebar">
                <h1 className="title">‎ </h1>
            </div>
            <motion.div
                className="card-container"
                style={{perspective: "1000px"}}
                variants={variants}
                initial="initial"
                animate={phase} // si reset, repart à droite
                exit="exit"

                transition={{ duration: 0.5, ease: "easeInOut"  }}
                onAnimationComplete={(e) => {
                    if(e == "initial")
                        setTimeout(() => setPhase("enter"), 10);
                    else if(e == "exit") {
                        setPhase("initial");
                        setCurrentIndex(currentIndex+1);
                    }              
                }}
            >
                <motion.div
                    className="title-view"
                >
                    <h1 className="title">{roles.length > 0 ? roles[currentIndex].name : "Attributions"}</h1>
                </motion.div>

                {roles.length > 0 && roles[currentIndex].students.map(data => (<Card id={update} name={data} />))}
            </motion.div>
            <div className="action-div">
                {currentIndex >= roles.length-1 ? <button onClick={end}>Terminé</button> : <button onClick={next}>Suivant</button>}
            </div>
        </div>
        </>

    )
    
}

function Card({ id, name }) {
    let [isFlipped, setIsFlipped] = useState(false);

    function onClick(e) {
        setIsFlipped(true);
    }

    useEffect(() => {
        setIsFlipped(false);
    }, [id])

    return (
        <motion.div
            animate={{ rotateY: isFlipped ? "180deg" : "0"}}
            transition={{ duration: 0.5, ease: "easeOut" }}
            style={{
                width: "100%",
                height: "100%",
                position: "relative",
                transformStyle: "preserve-3d",
                backfaceVisibility: "hidden",
                paddingTop: "5vh"
            }}
            onClick={onClick}
        >
            <motion.div
                style={{
                    backfaceVisibility: "hidden",
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <CardBack />
            </motion.div>

            <motion.div
                style={{
                    backfaceVisibility: "hidden", // Ensures only one side is visible
                    position: "absolute",
                    transform: "rotateY(180deg)", // Flips the back face
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <CardFront name={name} />
            </motion.div>
        </motion.div>
    )
}

function CardBack() {
    return (
        <div className="role-card role-card-back">
            <img className="role-card-img" src="/img/card.png" />
        </div>
    )
}

function CardFront({ name }) {
    return (
        <div className="role-card role-card-front">
            <div className="role-card-front-inner">
                <span className="role-card-front-name">{name}</span>

            </div>
        </div>
    )
}

export default RoleAnimation;